function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "M12.5555556,0 C14.5192347,0 16.1111111,1.6117749 16.1111111,3.6 C16.1111111,5.5882251 14.5192347,7.2 12.5555556,7.2 C11.731325,7.2 10.9725986,6.91603762 10.3696,6.43946439 L7.83893403,8.51616795 C8.01428453,8.94219327 8.11111111,9.40964776 8.11111111,9.9 C8.11111111,10.1823382 8.07901018,10.4570851 8.01830213,10.7207033 L11.6603845,12.6519674 C12.2254963,12.0647041 13.0151278,11.7 13.8888889,11.7 C15.6071081,11.7 17,13.110303 17,14.85 C17,16.589697 15.6071081,18 13.8888889,18 C12.1706697,18 10.7777778,16.589697 10.7777778,14.85 C10.7777778,14.6433912 10.7974235,14.4414282 10.8349267,14.2459217 L7.1924886,12.3149252 C6.54189011,13.0427557 5.60146117,13.5 4.55555556,13.5 C2.59187645,13.5 1,11.8882251 1,9.9 C1,7.9117749 2.59187645,6.3 4.55555556,6.3 C5.33917771,6.3 6.06359125,6.55667097 6.65126174,6.9915093 L9.25400672,4.93882691 C9.09014975,4.52496879 9,4.07314379 9,3.6 C9,1.6117749 10.5918764,0 12.5555556,0 Z",
  id: "\\u76F4\\u7EBF-7"
});

var SvgNavFission = function SvgNavFission(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    width: "18px",
    height: "18px",
    viewBox: "0 0 18 18",
    ref: svgRef
  }, props), _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgNavFission, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/nav_fission.cb27c05b.svg";
export { ForwardRef as ReactComponent };